export enum DownloadEvidencesFontSizes {
  sectionContentData = 7,
  sectionContentTitle = 8,
  sectionTitle = 9,
  shipment = 12,
  status = 10,
  title = 25,
}
